package de.connect2x.timmy

import de.connect2x.messenger.compose.view.composeViewModule
import de.connect2x.messenger.compose.view.notifications.notificationsModule
import de.connect2x.tim.compose.platformTimStartupModule
import de.connect2x.tim.compose.timViewModuleFactory
import de.connect2x.timmy.customcomponents.customComponentsModule
import de.connect2x.trixnity.messenger.extensions.tim.TIMConfiguration
import de.connect2x.trixnity.messenger.extensions.tim.TIMSpec
import de.connect2x.trixnity.messenger.extensions.tim.addTIMModule
import de.connect2x.trixnity.messenger.extensions.tim.httpclient.ConfigureHttpClient
import de.connect2x.trixnity.messenger.extensions.tim.httpclient.installTimeouts
import de.connect2x.trixnity.messenger.extensions.tim.httpclient.platformConfigureHttpClient
import de.connect2x.trixnity.messenger.i18n.DefaultLanguages
import de.connect2x.trixnity.messenger.i18n.I18n
import de.connect2x.trixnity.messenger.i18n.Languages
import de.connect2x.trixnity.messenger.i18n.platformGetSystemLangModule
import de.connect2x.trixnity.messenger.multi.MatrixMultiMessengerConfiguration
import de.connect2x.trixnity.messenger.platformMatrixMessengerSettingsHolderModule
import de.connect2x.trixnity.messenger.util.RootPath
import io.ktor.http.*
import org.koin.dsl.module

fun timmyConfiguration(
    timSpec: TIMSpec = BuildConfig.spec,
    overrideVzdUrl: Url? = null,
    overrideIdpUrl: Url? = null,
    overrideVersionCheckUrl: Url? = null,
    overrideHomeServerUrl: String? = null,
    disableDownloads: Boolean,
    customConfig: MatrixMultiMessengerConfiguration.() -> Unit = {},
    customTIMConfig: TIMConfiguration.() -> Unit = {},
    branding: Brand,
): MatrixMultiMessengerConfiguration.() -> Unit = multiMessengerConfig@{
    val notificationsDebugEnabled = BuildConfig.flavor == Flavor.DEV
    appName = branding.appName
    appId = BuildConfig.appId
    privacyInfo = Constants.PRIVACY_LINK
    imprint = Constants.IMPRINT_LINK
    licenses = BuildConfig.licenses
    // sendLogsEmailAddress = ""
    urlProtocol = BuildConfig.appId
    pushUrl = "https://sygnal.demo.timmy-messenger.de/_matrix/push/v1/notify"
    modulesFactories += listOf(
        { composeViewModule(null) },
        { notificationsModule(this@multiMessengerConfig, notificationsDebugEnabled) },
        // TODO this needs to be removed and fixed, as there is no MatrixMessengerSettingsHolderImpl at MultiMessenger level!
        ::platformMatrixMessengerSettingsHolderModule,
        // TODO there should be a more clean way for I18n
        ::platformGetSystemLangModule,
        {
            module {
                single<Languages> { DefaultLanguages }
                single<I18n> { object : I18n(get(), get(), get(), get()) {} }
            }
        },
        timViewModuleFactory(timSpec),
        branding.themeModule,
    )

    when (BuildConfig.flavor) {
        Flavor.PROD, Flavor.REF -> {}
        Flavor.DEV -> {
            modulesFactories += {
                module {
                    val devRootPath = getDevRootPath()
                    if (devRootPath != null) single<RootPath> { devRootPath }
                }
            }
        }
    }

    messengerConfiguration messengerConfig@{
        // needed for TIM
        defaultPresenceIsPublic = false
        defaultReadMarkerIsPublic = false
        defaultTypingIsPublic = false
        useRefreshTokens = true

        val colors =
            listOf(
                0xAAB749C7,
                0xAAC77849,
                0xAA59C749,
            )
        generateInitialAccountColor = { alreadyUsedColors: Set<Long> ->
            colors.firstOrNull { alreadyUsedColors.contains(it).not() } ?: 0xFF333333
        }

        modulesFactories += listOf(
            { composeViewModule(this) },
            { notificationsModule(this@messengerConfig, notificationsDebugEnabled) },
            timViewModuleFactory(timSpec),
            branding.themeModule,
            ::platformTimStartupModule
        )
    }

    addTIMModule(timSpec) {
        version = BuildConfig.version
        clientId = "AKQPROWA"
        productAbbreviation = "AKQPROWA"
        manufacturerId = "AKNET"
        versionCheckUrl = overrideVersionCheckUrl

        // TIMConfiguration flavors
        when (BuildConfig.flavor) {
            Flavor.PROD -> {
                vzdUrl = overrideVzdUrl ?: TIMConfiguration.DefaultVzdUrls.production
                idpUrl = overrideIdpUrl ?: TIMConfiguration.DefaultIdpUrls.production
            }

            Flavor.REF -> {
                vzdUrl = overrideVzdUrl ?: TIMConfiguration.DefaultVzdUrls.reference
                idpUrl = overrideIdpUrl ?: TIMConfiguration.DefaultIdpUrls.reference
            }

            Flavor.DEV -> {
                vzdUrl = overrideVzdUrl ?: TIMConfiguration.DefaultVzdUrls.reference
                idpUrl = overrideIdpUrl ?: TIMConfiguration.DefaultIdpUrls.reference
                disableFederationCheck = true
                // TODO needs to be updated every 30 days
//                customVzdSearchAccessToken =
//                    "eyJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NTMzMzk2NjMsInVzZXJuYW1lIjoibXRoaWVsZSJ9.33QoClnbzm-peQfs-kNJjY050aFjDQMIfmmPOV1CvNI"
            }
        }

        customTIMConfig()
    }

    when (BuildConfig.flavor) {
        Flavor.PROD, Flavor.REF -> {}
        Flavor.DEV -> {
            modulesFactories += {
                module {
                    val devRootPath = getDevRootPath()
                    if (devRootPath != null) single<RootPath> { devRootPath }
                    single<ConfigureHttpClient>(createdAtStart = true) {
                        val configuration = get<MatrixMultiMessengerConfiguration>()
                        val timConfiguration = get<TIMConfiguration>()
                        val wrapped = platformConfigureHttpClient(configuration, timConfiguration) {
                            // don't set any connection spec, we want to allow TLS in DEV
                        }
                        ConfigureHttpClient {
                            wrapped.configure()
                            configuration.httpClientConfig = {
                                installTimeouts(timConfiguration)
                            }
                        }.apply { configure() }
                    }
                }
            }
        }
    }

    messengerConfiguration {
        downloadsDisabled = disableDownloads
        defaultHomeServer = overrideHomeServerUrl
        features.enablePdfReader = false
    }

    customConfig()

    messengerConfiguration {
        modulesFactories += listOf(
            ::customComponentsModule
        )
    }
}

internal expect fun getDevRootPath(): RootPath?
